// extracted by mini-css-extract-plugin
module.exports = {"sg6h9on":"sg6h9on"};